import { getBoosterProjectById } from 'API/booster-project';
import { ProfileValues } from 'types/profile.types';
import { Genres } from 'enums';
import { useUserData } from 'hooks/use-user-data';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import useErrorStore from 'stores/error-store';

export interface BoosterProject {
  _id: string;
  projectName: string;
  occupation: string;
  profile?: ProfileValues;
  genre: Genres;
  offer: string;
  createDate: string;
  creator: string;
  score?: number;
  text?: string;
  problems: string;
  assessment?: string;
}

export const useQueryProject = (): BoosterProject | undefined => {
  useUserData();
  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const [searchParams] = useSearchParams();
  const [project, setProject] = useState<BoosterProject>();

  useEffect(() => {
    const queryProject = searchParams.get('project');

    if (!_.isNil(queryProject)) {
      (async function () {
        const response = await getBoosterProjectById(queryProject);

        if (response && !response.error) {
          setProject(response);
        } else {
          handleOpenErrorDialog(response?.error, '/projects/boosters/:projectId', 'get');
        }
      })();
    }
  }, []);

  return project;
};
